/* eslint-disable */
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import React, { useState } from 'react';
import { InputLabel, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { UseTimeFieldProps } from '@mui/x-date-pickers/TimeField';
import {
  BaseSingleInputFieldProps,
  TimeValidationError,
  FieldSection,
} from '@mui/x-date-pickers/models';
import { TimesheetIcon } from '../../../icons';
import { CommonElementProps } from '../types';
import { twMerge } from 'tailwind-merge';
import ElementUtils from '../utils';

export type TimeValue = moment.Moment | null | undefined;
export interface TimePickerProps extends CommonElementProps<TimeValue> {
  value?: TimeValue;
  onChange?: (value: moment.Moment | null) => void;
  label?: string;
}
interface ButtonFieldProps
  extends UseTimeFieldProps<moment.Moment>,
  BaseSingleInputFieldProps<moment.Moment | null, FieldSection, TimeValidationError> {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  error?: boolean;
  label?: any;
  value?: TimeValue;
}

function ButtonField(props: ButtonFieldProps) {
  const {
    setOpen,
    // controlledValue,
    label,
    error,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
    value,
  } = props;
  const start = value ? moment(value) : null;
  console.log('value time', value);
  const formatted = value ? `${start?.format("hh:mm a")}` : "Select Time";

  return (
    <Button
      // variant="outlined"
      color="secondary"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
      startIcon={<TimesheetIcon />}
      className={twMerge('w-[275px] justify-start custom-shadow', error && 'outline outline-[1px] outline-error')}
    >
      <div className='justify-center w-full'>{formatted}</div>
    </Button>
  );
}

const CustomTimePicker = function CustomDatePicker(props: TimePickerProps) {
  const {
    value: defaultValue,
    onChange,
    label,
    error,
    disabled,
  } = props;
  const [value, setValue] = React.useState<TimeValue>(null);
  const [timeOpen, setOpen] = useState(false);

  React.useEffect(() => {
    setValue(defaultValue ? moment(defaultValue) : null);
  }, [defaultValue]);

  const handleTimeChange = (newValue: moment.Moment | null) => {
    if (onChange) {
      onChange(newValue);
    } else {
      setValue(newValue);
    }
  };

  const handleTimeClose = () => {
    setOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack direction="column" justifyContent="flex-start" className="text-left relative">
        <InputLabel error={Boolean(error)} className="text-[14px] font-semibold mb-1 text-[#28364C]">{label}</InputLabel>
        <Stack direction="row" gap={2} alignItems="space-between">
          <TimePicker
            value={value ? moment(value) : null}
            open={timeOpen}
            onChange={handleTimeChange}
            onClose={handleTimeClose}
            disabled={disabled}
            slots={{ field: ButtonField }}
            slotProps={{
              field: { value, label, setOpen, error: Boolean(error) } as any,
            }}
          />
        </Stack>
        {error && (
          <div className="absolute -bottom-5 text-error text-xs">
            {ElementUtils.renderError(error)}
          </div>
        )}
      </Stack>
    </LocalizationProvider>
  );
};

CustomTimePicker.defaultProps = {
  onChange: () => { },
};

CustomTimePicker.propTypes = {

};
export default CustomTimePicker;
